<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('openNotificationPanel');
      }
    },
  },
};
</script>

<template>
  <button
    class="topnav-item relative flex items-center justify-center w-9 h-9 p-0 rounded-lg transition-colors duration-150 flex-shrink-0"
    :class="{ 'topnav-item--active': isNotificationPanelActive }"
    @click="openNotificationPanel"
  >
    <fluent-icon icon="alert" size="16" />
    <span
      v-if="unreadCount"
      class="topnav-item__badge absolute -top-1 -right-1"
    >
      {{ unreadCount }}
    </span>
  </button>
</template>
